<template>
  <transition name="el-zoom-in-top">
    <div class="content-wrapper">
      <!-- Main content -->
      <section class="content-noneheader">
        <!-- Multiple select-->
        <div class="box">
          <div class="box-header with-border">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item>系统配置</el-breadcrumb-item>
              <el-breadcrumb-item>配置列表</el-breadcrumb-item>
            </el-breadcrumb>
          </div>

          <div class="box-body" style="min-height:80%;min-width:100%">
            <div class="search-div">
              <el-input v-model="configName" placeholder="请输入配置名" class="input-size-200 input-margin-right"></el-input>
              <el-button type="success" icon="el-icon-plus" class="button-pull-right" style="margin-left: 20px"
                         @click="handleCreate()">新增
              </el-button>
              <el-select v-model="category" filterable clearable placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <el-button type="primary" icon="el-icon-search" class="button-pull-right" @click="search()">搜索</el-button>
              <br/>
            </div>
            <el-table
              ref="multipleTable"
              :data="dt.data"
              :stripe="true"
              border
              highlight-current-row
              style="width: 100%"
              :size="dt.size"
              @sort-change="dt.handleSortChange"
              @selection-change="dt.handleSelectionChange">
              <el-table-column
                type="selection"
                min-width=5%>
              </el-table-column>
              <el-table-column
                property="id"
                label="ID"
                min-width=5%>
              </el-table-column>
              <el-table-column
                property="categoryLabel"
                label="分类"
                sortable="custom"
                min-width=10%
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                property="configLabel"
                label="来源"
                min-width=35%
                sortable="custom">
              </el-table-column>
              <el-table-column
                property="value"
                label="值"
                min-width=25%
                sortable="custom">
              </el-table-column>
              <el-table-column
                label="操作"
                min-width=20%>
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="handleEdit(scope.$index, scope.row)">编辑
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              @size-change="dt.handleSizeChange"
              @current-change="dt.handleCurrentChange"
              :current-page="dt.currentPage"
              :page-sizes="dt.pageSizes"
              :page-size="dt.pageSize"
              :layout="dt.layout"
              :total="dt.totalElements">
            </el-pagination>
          </div>
        </div>
        <!-- End of Multiple select-->
      </section>
      <!-- /.content -->
    </div>
  </transition>
</template>
<script>
  import {DataTable} from "../../../data-table";

  export default {
    name: 'ConfigList',
    data: function () {
      let that = this;
      return {
        //  表格设置
        filter: [],
        dt: DataTable.getInstance(that, '/admin/config/findPage'),

        configName: '',
        category: '',
        options: []
      }
    },

    mounted: function () {
      this.getCategory();
      //  还原过滤设置
      let filters = this.dt.filters;
      if (filters != null && filters instanceof Array) {
        for (let i = 0; i < filters.length; i++) {
          let f = filters[i];
          switch (f.name) {
            case "configLabel":
              this.configName = f.value;
              break;
            case "category":
              this.category = f.value;
              break;
          }
        }
      }

      //  向后台查询数据
      this.dt.queryPageData();
    },

    methods: {
      //  创建新记录
      handleCreate: function () {
        this.$router.push('/config/configModify')
      },
      // 编辑记录
      handleEdit: function (index, row) {
        // console.debug(index + ' ' + row.id)
        this.$router.push({path: '/config/configModify', query: {id: row.id}})
      },
      search: function () {
        if (this.filter) {
          this.filter.length = 0;
        }
        if (this.configName !== '') {
          let key = {};
          key.name = 'configLabel'
          key.value = this.configName
          key.type = 'string'
          this.filter.push(key)
        }
        if (this.category !== '') {
          let key = {};
          key.name = 'category'
          key.value = this.category
          key.type = 'string'
          this.filter.push(key)
        }
        this.dt.filters = this.filter;
        this.dt.queryPageData()
      },
      getCategory: function () {
        this.axios.get('/admin/config/getCategory', null).then(resp => {
          var result = resp.data.data
          this.options = result
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ConfigList.vue?7e67e41d